
<ng-container *ngIf="isLoaded">
  <apx-chart
  [series]="chartOptions.series"
  [chart]="chartOptions.chart"
  [labels]="chartOptions.labels"
  [responsive]="chartOptions.responsive"
></apx-chart>
</ng-container>

